import { Injectable } from "@angular/core";

@Injectable()
export class JwtService {
  public getToken(): string {
    return window.localStorage["jwtToken"];
  }

  public saveToken(token: string) {
    window.localStorage["jwtToken"] = token;
  }

  public destroyToken() {
    window.localStorage.removeItem("jwtToken");
  }
}
